
import { PeriodStatusModel } from "app/pages/collaborators/models/PeriodStatus";
import { BondCollaboratorDepartmentAllResponse, PeriodStatusAllResponse } from "app/types/Ajustes";
import axios from "axios";
const API_URL = process.env.REACT_APP_API_NET;

export async function getAllPeriodsStatus(page: number | string, pageSize: number | string) {
  try {
    const response = await axios.get<PeriodStatusAllResponse>(`${API_URL}BondsDepartment/PeriodStatus?page=${page}&pageSize=${pageSize}`);
    return response.data.data;
  } catch (err) {
    console.error("Error fetching PeriodStatus");
    throw err;
  }
}

//ENDPOINT - /BondsDepartment/BondCollaboratorDepartment
export async function getAllBondsCollaboratorsDepartments(page: number | string, pageSize: number | string, idUsuario: number | string, periodId?: number | string) {
    try {
      const response = await axios.get<BondCollaboratorDepartmentAllResponse>(`${API_URL}BondsDepartment/BondCollaboratorDepartment?id_usuario=${idUsuario}&page=${page}&pageSize=${pageSize}${periodId ? `&PeriodId=${periodId}` : ''}`);

      return response.data.data;
    } catch (err) {
      console.error("Error fetching BondCollaboratorDepartment");
      throw err;
    }
}

export async function getAllBondsCollaboratorsDepartmentsName(page: number | string, pageSize: number | string, idUsuario: number | string, employeeName?: string, periodId?: number | string) {
  try {
    //ENDPOINT - /BondsDepartment/BondCollaboratorDepartmentByEmployeeName
    const response = await axios.get<BondCollaboratorDepartmentAllResponse>(`${API_URL}BondsDepartment/BondCollaboratorDepartmentByEmployeeName?id_usuario=${idUsuario}&EmployeeName=${employeeName}&Page=${page}&PageSize=${pageSize}${periodId ? `&PeriodId=${periodId}` : ''}`);

    return response.data.data;
  } catch (err) {
    console.error("Error fetching filter Name");
    throw err;
  }
}

export async function getAllBondsCollaboratorsDepartmentsNumber(page: number | string, pageSize: number | string, idUsuario: number | string, employeeNumber?: string, periodId?: number | string) {
  try {
    //ENDPOINT - /BondsDepartment/BondCollaboratorDepartmentByEmployeeNumber
    const response = await axios.get<BondCollaboratorDepartmentAllResponse>(`${API_URL}BondsDepartment/BondCollaboratorDepartmentByEmployeeNumber?id_usuario=${idUsuario}&EmployeeNumber=${employeeNumber}&page=${page}&pageSize=${pageSize}${periodId ? `&PeriodId=${periodId}` : ''}`);

    return response.data.data;
  } catch (err) {
    console.error("Error fetching filter Number");
    throw err;
  }
}

//TEMPLATE 
export async function updateBondDepartment(body: PeriodStatusModel, id: any) {
  let response;
  try {
    response = await axios.put(`${API_URL}BondsDepartment/${id}/update`, body);
    return response.data;
  } catch (err) {
    console.error("Error en actualizar el BondDepartment:", err);
    throw err; // Propagamos el error para manejarlo en el hook
  }
}

export async function putRequestOpening(idUser: number | string, idPeriod: number | string) {
  try {
    const response = await axios.put(`${API_URL}CollaboratorBonds/PutRequestOpening?Id_user=${idUser}&Id_period=${idPeriod}`);
    return response.data;
  } catch (err) {
    console.error("Error en putRequestOpening:", err);
    throw err;
  }
}

export async function putOpeningAuthorization(idUser: number | string, idPeriod: number | string) {
  try {
    const response = await axios.put(`${API_URL}CollaboratorBonds/PutOpeningAuthorization?Id_user=${idUser}&Id_period=${idPeriod}`);
    return response.data;
  } catch (err) {
    console.error("Error en putOpeningAuthorization:", err);
    throw err;
  }
}